import React from "react"
import { StyledSpinner } from "./Spinner.style"

export const Spinner = () => <StyledSpinner />
